import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { Box, Button, Typography } from "@mui/material";
import {
  statusColors,
  statusPanelSx,
  statusSectionTitleSx,
} from "../statusStyles";
import type { ClaimTranslator, ReturnLabel } from "../types";

type ReturnLabelPanelProps = {
  label: ReturnLabel | null;
  t: ClaimTranslator;
};

export const ReturnLabelPanel = ({ label, t }: ReturnLabelPanelProps) => {
  if (!label?.label_url) {
    return null;
  }

  return (
    <Box mb="16px" sx={statusPanelSx(true)}>
      <Typography sx={{ ...statusSectionTitleSx, mb: "8px" }}>
        {t("status.returns.labelPanel.title")}
      </Typography>
      <Typography fontSize="14px" color={statusColors.bodyText} mb="12px">
        {t("status.returns.labelPanel.instructions")}
      </Typography>
      {label.tracking_number ? (
        <Typography fontSize="14px" color={statusColors.metaText} mb="12px">
          {t("status.returns.labelPanel.trackingNumber", {
            trackingNumber: label.tracking_number,
          })}
        </Typography>
      ) : null}
      <Button
        variant="contained"
        href={label.label_url}
        target="_blank"
        rel="noreferrer"
        startIcon={<FileDownloadOutlinedIcon />}
      >
        {t("status.returns.labelPanel.download")}
      </Button>
    </Box>
  );
};
